module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-uk.800fcf7f3a63d21be04b.svg";